/**
 * EventDetailSkeleton — the shape of the event page, before the event arrives.
 *
 * The generic public skeleton draws a six-card grid, which is the shape of a
 * LISTING. On this page it promised something that never appeared and then
 * jumped into a completely different layout. This traces what actually loads:
 * the cover band, the four facts, the about card, two activity cards and the
 * entry rail.
 *
 * It reuses the page's own stylesheet, so the blocks sit exactly where the real
 * content will — the load is a dimmer version of the page rather than a
 * different page.
 */

import React from 'react';
import '../../../styles/eventDetail.css';

function Bar({ w = '100%', h = 14, mt = 0 }) {
  return <span className="evb-sk__bar" style={{ width: w, height: h, marginTop: mt }} />;
}

export default function EventDetailSkeleton() {
  return (
    <div className="evb evb-sk" aria-busy="true" aria-label="Loading this event">
      <div className="evb-zone">

        <div className="evb-hero evb-sk__hero">
          <div className="evb-hero__in">
            <Bar w="120px" h={22} />
            <Bar w="min(420px, 70%)" h={34} mt={12} />
            <Bar w="220px" h={13} mt={10} />
          </div>
        </div>

        <div className="evb-grid">
          <div className="evb-main">

            <div className="evb-facts">
              {['Event starts', 'Event ends', 'Number of activities', 'Format'].map(key => (
                <div className="evb-fact" key={key}>
                  <span>{key}</span>
                  <Bar w="80%" h={15} mt={4} />
                </div>
              ))}
            </div>

            <section className="evb-sec">
              <Bar w="240px" h={24} />
              <Bar w="120px" h={13} mt={10} />
              <Bar w="100%" h={13} mt={16} />
              <Bar w="86%" h={13} mt={8} />
            </section>

            <section className="evb-sec">
              <Bar w="160px" h={19} />
              {[0, 1].map(i => (
                <div className="evb-cat evb-sk__cat" key={i}>
                  <div className="evb-cat__hd"><Bar w="40%" h={16} /></div>
                  <div className="evb-cat__facts">
                    <div><Bar w="70%" h={13} /></div>
                    <div><Bar w="100%" h={72} /></div>
                    <div><Bar w="100%" h={72} /></div>
                  </div>
                </div>
              ))}
            </section>

          </div>

          <aside className="evb-rail">
            <div className="evb-card">
              <Bar w="140px" h={28} />
              <Bar w="80px" h={12} mt={8} />
              <div className="evb-dl">
                {[0, 1, 2].map(i => (
                  <div key={i}><Bar w="45%" h={13} /><Bar w="30%" h={13} /></div>
                ))}
              </div>
              <Bar w="100%" h={42} mt={14} />
            </div>
          </aside>
        </div>

      </div>
    </div>
  );
}
